import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';
import Immutable from 'immutable';

import config from 'config/global';
import { range } from 'utils/utils';

import './SearchUnitRooms.scss';

export default class SearchUnitRooms extends Component {
  static propTypes = {
    resetSearchForm: PropTypes.func,
    baseState: PropTypes.object,
    searchUnitActionsBound: PropTypes.object,
  };

  state = {
    expandedRoomIndex: 0,
  }

  shouldComponentUpdate = shouldPureComponentUpdate;

  onNumberOfAdultsChange = (event) => {
    const { searchUnitActionsBound } = this.props;
    const roomNumber = Number(event.currentTarget.getAttribute('data-room-number'));

    const numberOfAdults = event.currentTarget.value;

    searchUnitActionsBound.changeNumberOfAdults(roomNumber, numberOfAdults, this.partyRefs[roomNumber], this.childrenAgesRefs);
  }

  onNumberOfChildrenChange = (event) => {
    const { searchUnitActionsBound } = this.props;
    const roomNumber = Number(event.currentTarget.getAttribute('data-room-number'));
    const numChildren = Number(event.currentTarget.value);

    if (numChildren > 0) {
      this.setState({
        expandedRoomIndex: roomNumber,
      });
    }

    searchUnitActionsBound.changeNumberOfChildren(roomNumber, numChildren, this.partyRefs[roomNumber], this.childrenAgesRefs);
  }

  onChildAgeChange = (event) => {
    const roomNumber = Number(event.currentTarget.getAttribute('data-room-number'));
    const childNumber = Number(event.currentTarget.getAttribute('data-child-number'));
    const { searchUnitActionsBound } = this.props;
    const childAge = event.currentTarget.value;

    searchUnitActionsBound.changeChildAge(roomNumber, childNumber, childAge, this.partyRefs[roomNumber], this.childrenAgesRefs);
  }

  savePartyRefs = (ref) => {
    if (ref === null) {
      return;
    }

    const roomNumber = Number(ref.getAttribute('data-room-number'));

    this.partyRefs = this.partyRefs || [];
    this.partyRefs[roomNumber] = ref;
  }

  childAgeSelectRef = (ref) => {
    this.childrenAgesRefs = this.childrenAgesRefs || [];
    const maxNumberOfAgeSelects = 4;

    if (this.childrenAgesRefs.length < maxNumberOfAgeSelects) {
      this.childrenAgesRefs.push(ref);
    }
  }

  addRoom = (event) => {
    event.preventDefault();
    const { searchUnitActionsBound } = this.props;

    searchUnitActionsBound.addRoom();
  }

  removeRoom = (event) => {
    const roomNumber = Number(event.currentTarget.getAttribute('data-room-number'));
    event.preventDefault();

    const { searchUnitActionsBound } = this.props;

    searchUnitActionsBound.removeRoom(roomNumber);
  }

  expandRoom = (event) => {
    const { searchUnitActionsBound } = this.props;
    const roomNumber = Number(event.currentTarget.getAttribute('data-room-number'));
    event.preventDefault();

    searchUnitActionsBound.resetChildCountIfNotAllAgesSet(this.state.expandedRoomIndex);

    this.setState({
      expandedRoomIndex: roomNumber,
    });
  }

  render() {
    const { baseState } = this.props;
    const rooms = baseState.getIn(['queryState', 'props', 'rooms'], Immutable.List());

    return (
      <div className="search-unit-rooms">
        { rooms.map((room, roomIndex) => {
          const adultsCount = room.getIn(['nAdt', 'value']) || 0;
          const childAges = room.getIn(['cdn', 'arrayValue'], Immutable.List());
          const isRoomExpanded = roomIndex === this.state.expandedRoomIndex;

          return (
            <div key={roomIndex} className="search-unit-rooms__wrapper">
              <div className="search-unit-rooms__room" ref={this.savePartyRefs} data-room-number={roomIndex}>
                { roomIndex > 0 && (<div className="search-unit-rooms__room__number">Room {roomIndex + 1}:</div>)}
                <label className="search-unit-rooms__room__adults">
                  <span className="search-unit-rooms__room__adults__label">Adults:</span>
                  <select onChange={this.onNumberOfAdultsChange} value={Number(adultsCount)} data-room-number={roomIndex}>
                    { config.adultsOptions.map((numAdults, i) =>
                      <option value={numAdults} key={i}>{numAdults}</option>,
                    )}
                  </select>
                </label>

                <label className="search-unit-rooms__room__children">
                  <span className="search-unit-rooms__room__children__label">Child 0-17:</span>
                  <select onChange={this.onNumberOfChildrenChange} value={childAges.size} data-room-number={roomIndex}>
                    { config.childrenOptions.map((numChildren, i) =>
                      <option value={numChildren} key={i}>{numChildren}</option>,
                    )}
                  </select>
                </label>
              </div>

              { isRoomExpanded ? (
                <div className={`search-unit-rooms__child-ages ${childAges.size === 0 ? 'search-unit-rooms__child-ages--hidden' : ''}`}>
                  { range(0, 4).map((item, childIndex) => (
                    <div className="search-unit-rooms__child-ages__age" ref={this.childAgeSelectRef} key={childIndex}>
                      <label
                        className={`search-unit-rooms__child-ages__age__inner ${childIndex < childAges.size ? '' : 'search-unit-rooms__child-ages__age__inner--hidden'}`}
                      >
                        <span className="search-unit-rooms__child-ages__age__label">Child {childIndex + 1}:</span>
                        <span className="search-unit-rooms__child-ages__age__select">
                          <select onChange={this.onChildAgeChange} data-room-number={roomIndex} data-child-number={childIndex} value={String(childAges.get(childIndex))}>
                            <option value="-1">Select Age</option>
                            { range(0, config.maxChildAge + 1).map((age, ageIndex) =>
                              <option value={`${age}`} key={ageIndex}>{age}</option>,
                            )}
                          </select>
                        </span>
                      </label>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="search-unit-rooms__child-ages--collapsed">
                  {(childAges.size !== 0) && (
                    <div><a href="#" onClick={this.expandRoom} data-room-number={roomIndex}>edit</a> Child Ages: {childAges.join(', ')}</div>
                  )}
                </div>
              )}
              { rooms.size > 1 && (
                <a href="#" onClick={this.removeRoom} className="search-unit-rooms__remove-room" data-room-number={roomIndex}>- Remove room</a>
              )}
            </div>
          );
        })}

        { rooms.size < config.maxNumberOfRooms && (
          <div className="search-unit-rooms__add-room">
            { baseState.get('areRoomsValid') === false ? (
              <span className="search-unit-rooms__add-room__link search-unit-rooms__add-room__link--disabled">+ Add another room</span>
            ) : (
              <a href="#" onClick={this.addRoom} className="search-unit-rooms__add-room__link">+ Add another room</a>
            )}
          </div>
        )}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SearchUnitRooms/SearchUnitRooms.jsx
 **/